// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button:hover {
  background-color: #BE1E2D;
  color: white;
  cursor: pointer !important;
}

.scroll-content {
  overflow-y: hidden;
}

ion-backdrop {
  cursor: auto !important;
}

[tappable] {
  cursor: auto !important;
}

ion-label.label.label-md {
  text-align: left !important;
}

.log-user {
  padding: 1px 0px;
  background: #be1e2d;
}

.log-user p {
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  color: white;
  text-transform: capitalize;
}

.sync {
  margin: auto 10px auto 12px !important;
  font-size: 12px;
}

.item-cover {
  background: transparent !important;
}

ion-label.label.label-md {
  margin: 0px;
}

.input-wrapper {
  font-size: 12px;
}

.tap-btn {
  background: white;
  text-align: left;
  color: black;
  font-size: 16px;
  width: 100%;
  padding: 10px 15px;
}

.content-popover .popover-wrapper .popover-content {
  width: 170px !important;
  left: 175px !important;
}

.popover-content {
  top: 45px !important;
  left: 991px !important;
  bottom: 0px;
}

ion-backdrop {
  cursor: auto !important;
}`, "",{"version":3,"sources":["webpack://./src/app/context-menu/context-menu.page.scss"],"names":[],"mappings":"AACA;EACI,yBAAA;EACA,YAAA;EACA,0BAAA;AAAJ;;AAGA;EACI,kBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,uBAAA;AAAJ;;AAGA;EACI,2BAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;AACJ;;AAEA;EACI,sCAAA;EACA,eAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,oBAAA;EACA,sBAAA;EACA,WAAA;AACJ;;AACC;EACM,uBAAA;AAEP","sourcesContent":["$popover-md-width: 100px;\nbutton:hover {\n    background-color: #BE1E2D;\n    color: white;\n    cursor : pointer !important;\n}\n\n.scroll-content {\n    overflow-y: hidden;\n}\n\nion-backdrop {\n    cursor: auto !important;\n}\n\n[tappable] {\n    cursor: auto !important;\n}\n\nion-label.label.label-md {\n    text-align: left !important;\n}\n\n.log-user {\n    padding: 1px 0px;\n    background: #be1e2d;\n}\n.log-user p {\n    font-size: 12px;\n    font-weight: bold;\n    text-align: center;\n    color: white;\n    text-transform: capitalize;\n}\n\n.sync {\n    margin: auto 10px auto 12px !important;\n    font-size: 12px;\n}\n\n.item-cover {\n    background: transparent !important;\n}\n\nion-label.label.label-md {\n    margin: 0px;\n}\n\n.input-wrapper {\n    font-size: 12px;\n}\n\n.tap-btn{\n    background: white;\n    text-align: left;\n    color: black;\n    font-size: 16px;\n    width: 100%;\n    padding: 10px 15px;\n}\n\n.content-popover .popover-wrapper .popover-content{\n    width: 170px !important;\n    left: 175px !important;\n}\n\n.popover-content{\n    top: 45px !important;\n    left: 991px !important;\n    bottom : 0px;\n }\n ion-backdrop{\n       cursor: auto !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
